module.exports = __webpack_public_path__ + "static/media/view1.c0c49d4c.jpg";